import {GroupListView} from './view';
import {Group} from '../../graphql';

interface GroupListContainerProps {
  groups: Array<Group>;
}

export const GroupListContainer = (props: GroupListContainerProps) => {
  return <GroupListView groups={props.groups}/>;
}
